import { render } from "./AppPreloader.vue?vue&type=template&id=84b442bc&scoped=true"
import script from "./AppPreloader.vue?vue&type=script&lang=js"
export * from "./AppPreloader.vue?vue&type=script&lang=js"

import "./AppPreloader.vue?vue&type=style&index=0&id=84b442bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b442bc"]])

export default __exports__